import ResetPasswordContainer from "../../../../Components/OtherPages/Authentication/ResetPassword/ResetPassword"

const ResetPassword = () => {
  return (
    <div className='page-body'>
      <ResetPasswordContainer />
    </div>
  )
}

export default ResetPassword